module.exports = __webpack_public_path__ + "assets/droplet-task.e7c8d8bd.svg";